import { IEnvVars } from 'shared/utils';

const QA_ENV_VARS: IEnvVars = {
  API_ENDPOINT: 'https://rdr-web-exp-api.qaerospace1.honaero.com',
  ASDS_ENDPOINT: 'https://qads.honeywellaerospace.com/ads/broadcast/message',
  ASDS_ERROR_ENDPOINT:
    'https://stage.honeywellaerospace.com/en/secure/learn/products/weather-radar/rdr-7000/software-configuration',
  ASDS_GET_HELP: 'https://www.honeywellaerospace.com/en/pages/rdr-7k-support',
};

export default QA_ENV_VARS;
